export const brand = [
  'Tesla',
  'BMW',
  'Ferrari',
  'Ford',
  'Porsche',
  'Honda',
  'Lamborghini',
  'Toyota',
  'Bentley',
  'Maserati',
  'Audi',
  'Jeep',
  'Subaru',
  'Cadillac',
  'Chrysler',
  'Chevrolet Corvette',
  'Dodge',
  'Hyundai',
  'Jaguar',
  'Mazda',
  'Ford Mustang',
  'Nissan',
  'Alfa Romeo',
  'Bugatti',
  'Buick',
  'Lexus',
  'Rolls-Royce',
  'Acura',
  'Aston Martin',
  'Chevrolet',
  'Kia',
  'Mercedes-Benz',
  'Volkswagen',
  'Volvo',
  'McLaren',
  'Mitsubishi',
  'GMC',
  'Infiniti',
  'Lincoln',
  'Peugeot',
  'Pontiac',
  'Saab',
  'Genesis',
  'Suzuki',
  'Citroën',
  'Fiat',
  'Lotus',
  'Mini',
  'Peterbilt',
  'Saturn',
  'BMW M',
  'General Motors',
  'Kenworth',
  'KTM',

  'Land Rover',
  'Maybach',
  'Mercury',
  'Oldsmobile',
  'Renault',
  'Dodge Viper',
  'Koenigsegg',
  'Mack',
  'Scion',
  'Škoda',
  'Daewoo',
  'Daimler',
  'Opel',
  'Datsun',
  'Holden',
  'Smart',
  'Alpine',
  'DS',
  'Navistar',
  'Nissan Nismo',
  'Pagani',
  'Rover',
  'Vauxhall',
  'Ariel',
  'Isuzu',
  'Paccar',
  'Tata',
  'Abarth',
  'Hummer',
  'SEAT',
  'Karma',
  'Lucid',
  'Saleen',
  'Studebaker',
  'Western Star',
  'Mercedes-AMG',
  'Hennessey',
  'Audi Sport',
  'Dacia',
  'Daihatsu',
  'Fisker',
  'Geo',
  'Hino',
  'Scania',
  'Sterling',
  'Packard',
  'Great Wall',
  'Eicher',
  'International',
  'IH',
  'RAM',
  'ABT',
  'BYD',
  'Geely',

  'Lada',
  'Noble',
  'Polestar',
  'MG',
  'VinFast',
  'SsangYong',
  'Alpina',
  'Brabus',
  'Jetta',
  'MAZ',
  'SAIC Motor',
  'MAN',
  'VLF',
  'Vencer',
  'Elemental',
  'Faraday Future',
  'Rimac',
  'SSC',
  'DeSoto',
  'GAC Group',
  'Irizar',
  'Hongqi',
  'NIO',
  'Rivian',
  'WEY',
  'ERF',
  'Spyker',
  'Toyota Crown',
  'Suffolk',
  'De Tomaso',
  'Freightliner',
  'IC Bus',
  'Tramontana',
  'Arash',
  'Artega',
  'Gumpert',
  'Tucker',
  'Wuling',
  'Sisu',
  'Carlsson',
  'Troller',
  'Tauro Sport Auto',
  'Tatra',
  'Spania GTA',
  'Vector',
  'Ascari',
  'Lagonda',
  'Mansory',
  'Panoz',
  'Rossion',
  'Canoo',
  'Arrival',
  'Lordstown',
  'Arrinera',

  'BharatBenz',
  'Haval',
  'Mahindra',
  'Mosler',
  'Trion',
  'Duesenberg',
  'Changan',
  'Chery',
  'GAZ',
  'Laraki',
  'Perodua',
  'Rezvani',
  'RUF',
  'TechArt',
  'Brilliance',
  'David Brown',
  'Hindustan Motors',
  'Iveco',
  'Keating',
  'LEVC',
  'Mazzanti',
  'TVR',
  'Zenvo',
  'Lynk & Co',
  'Arcfox',
  'Toyota Century',
  'Toyota Alphard',
  'Li Auto',
  'XPeng',
  'Weltmeister',
  'Nikola',
  'Workhorse',
  'Singulato',
  'NEVS',
  'Bestune',
  'Exeed',
  'Geometry',
  '9ff',
  'Aixam',
  'Apollo',
  'Autobacs',
  'BAIC Motor',
  'Baojun',
  'Bertone',
  'Borgward',
  'Brammo',
  'Caparo',
  'Caterham',
  'DAF',
  'Devel Sixteen',
  'DINA',
  'Dongfeng',
  'Edsel',
  'FAW',

  'Foton',
  'Ginetta',
  'Grinnall',
  'Nissan GT-R',
  'HSV',
  'Kamaz',
  'Lancia',
  'Ligier',
  'Lister',
  'Luxgen',
  'Melkus',
  'Microcar',
  'Mitsuoka',
  'Oltcit',
  'OSCA',
  'Pininfarina',
  'Praga',
  'Prodrive',
  'Proton',
  'Qoros',
  'Radical',
  'Renault Samsung',
  'Setra',
  'UAZ',
  'UD',
  'W Motors',
  'Yulon',
  'Zarooq Motors',
  'Zenos',
  'Stutz',
  'Karlmann King',
  'Byton',
  'FSO',
  'Drako Motors',
  'Aspark',
  'FAW Jiefang',
  'Sinotruk (CNHTC)',
  'Shacman',
  'Hongyan',
  'Dayun',
  'BeiBen',
  'CAMC',
  'Yutong',
  'King Long',
  'Golden Dragon',
  'Zhongtong',
  'Higer',
  'Zinoro',
  'HiPhi',
  'Leapmotor',
  'Zeekr',
  'Aiways',
  'AC',
  'Alvis',

  'Atalanta',
  'BAC',
  'Bitter',
  'Bowler',
  'Bufori',
  'Changfeng',
  'Dartz',
  'Detroit Electric',
  'DeLorean',
  'Donkervoort',
  'Eagle',
  'EDAG',
  'Elfin',
  'Eterniti',
  'Facel Vega',
  'Force',
  'FPV',
  'Haima',
  'Hawtai',
  'IKCO',
  'JAC',
  'Jawa',
  'JBA Motors',
  'JMC',
  'Landwind',
  'Lifan',
  'Lloyd',
  'Lobini',
  'Maxus',
  'Morgan',
  'Roewe',
  'Spirra',
  'Venucia',
  'Westfield',
  'Wiesmann',
  'Abadal',
  'Abbott-Detroit',
  'Alta',
  'AMC',
  'ARO',
  'Askam',
  'Auburn',
  'Austin',
  'Autobianchi',
  'Axon',
  'Berkeley',
  'Berliet',
  'Bizzarrini',
  'Bristol',
  'Brooke',
  'Cisitalia',
  'Cizeta',
  'Cole',
  'Corre La Licorne',

  'Delage',
  'Diatto',
  'DKW',
  'Elva',
  'Englon',
  'Fioravanti',
  'Foden',
  'Franklin',
  'Gardner Douglas',
  'Gilbern',
  'Gillet',
  'Gonow',
  'Hillman',
  'Hispano-Suiza',
  'Hommell',
  'Horch',
  'Hudson',
  'Hupmobile',
  'Innocenti',
  'Intermeccanica',
  'Isdera',
  'Iso',
  'Jensen',
  'Kaiser',
  'Leyland',
  'Marcos',
  'Marlin',
  'Mastretta',
  'Merkur',
  'MEV',
  'MK',
  'Morris',
  'Panhard',
  'Pegaso',
  'PGO',
  'Pierce-Arrow',
  'Plymouth',
  'Premier',
  'Rambler',
  'Riley',
  'Rinspeed',
  'Ronart',
  'Saipa',
  'Simca',
  'Singer',
  'Soueast',
  'Talbot',
  'Triumph',
  'Ultima',
  'Vandenbrink',
  'Venturi',
  'Wanderer',
  'Wartburg',
  'Willys-Overland',
  'Zastava',
  'ZAZ',
  'Zotye',
  'Hafei',
  'Ranz',
];
